import { useSuspenseQuery } from '@tanstack/react-query';
import { createFileRoute } from '@tanstack/react-router';
import { useEffect } from 'react';

import { getEvaluationCriteriaOptions } from '@/module/Evaluation/model/EvaluationQuery';

import { NoContentPlaceholder } from '@/core/components';

export const Route = createFileRoute('/_auth/evaluation/_layout/$evaluationId/_layout/report/gather/_gather/')({
  component: RouteComponent,
});

function RouteComponent() {
  const { evaluationId } = Route.useParams();
  const { data: criteria } = useSuspenseQuery(getEvaluationCriteriaOptions(evaluationId));
  const navigate = Route.useNavigate();

  useEffect(() => {
    if (criteria.length > 0) {
      navigate({
        to: `/evaluation/$evaluationId/report/gather/$orderNo`,
        params: { evaluationId, orderNo: String(criteria[0].orderNo) },
        search: true,
      });
    }
  }, [evaluationId, criteria, navigate]);

  return <NoContentPlaceholder title="Fara continut" />;
}
